import React from 'react';
import get from 'lodash/get';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {bindActionCreators} from 'redux';
import {Route, Switch} from 'react-router-dom';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withProps from 'recompose/withProps';
import setDisplayName from 'recompose/setDisplayName';
import ListUsersPage from 'pages/UserManagement/ListUsersPage';
import UserDetailPage from 'pages/UserManagement/UserDetailPage/UserDetailPage';
import {updatePageNumberForResourceAction} from 'resources/actions';
import {toggleSortForResourceAction} from 'viewOptions/actions';
import {createResourceTypeSelector} from 'resources/selectors';
import {PermissionsFilter} from 'hoc/authorization';
import * as ResourceApi from 'api/resources';
import {findByPathname} from 'utils/DBUtils';
import {
    setFilterResourceAction,
    setInitialColumnsAction,
    updateUserSelectionAction
} from './actions';
import userMgmtConfigs from './configs';

// this container is for passing the correct user mgmt UI config to the requested route.
//
// also handy for passing data to individual columns (like e.g. checkbox selection state)
// that the table itself doesn't need to know about.

const withUserReadPermissions = PermissionsFilter({
  [ResourceApi.Types.User]: ['READ']
});


const LockedListUsersPage = withUserReadPermissions(ListUsersPage);
const LockedUserDetailPage = withUserReadPermissions(UserDetailPage);

const mapStateToProps = (state, props) => {
  const {tableColumns} = state.userManagement;

  const {pathname} = props.history.location;
  const userMgmtConfig = findByPathname(userMgmtConfigs, pathname);

  return {
    // pass down the form creator, but as a thunk since it may not be needed (in the case
    // of statically-defined form configs)

    surveyName: userMgmtConfig.surveyName,
    tableColumns,
    userMgmtConfig
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  setInitialColumns: setInitialColumnsAction,
  setFilterResource: setFilterResourceAction,
  updateUserSelection: updateUserSelectionAction,
  updatePageNumberForResource: updatePageNumberForResourceAction,
  toggleSortForResource: toggleSortForResourceAction
}, dispatch);

const UserPageContainer = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentWillMount() {
      // if this UI is configured to generate its search form from a survey, fetch that survey.
      if (this.props.hubName && this.props.surveyName) {
        this.props.fetchSurvey(this.props.hubName, this.props.surveyName);
      }

      this.props.setFilterResource(this.props.userMgmtConfig.filterResource);
      this.props.setInitialColumns(this.props.userMgmtConfig.columns);
    }
  }),
  withProps(props => {
    // apply props to each visible column
    const colDetails = props.userMgmtConfig.columns
      .filter(({name}) => get(props.tableColumns.find(col => col.name === name), 'visible', true))
      .map(colDetail => colDetail(props));

    // generate form config dynamically from fetched survey, if it hasn't been statically defined.
    const searchFormConfig = props.userMgmtConfig.searchFormConfig || props.generateHubFormConfig();

    return {
      ...props.userMgmtConfig,
      colDetails,
      searchFormConfig
    };
  }),
  setDisplayName('UserPageContainer')
)(props => (
  <Switch>
    <Route path='/users' render={() => (<LockedListUsersPage {...props} />)} />
    <Route path='/user/:userId' render={() => (<LockedUserDetailPage {...props} />)} />
  </Switch>
));

export default UserPageContainer;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserPageContainer.js